"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SIGN_UP_BUTTON_TEXT = exports.PASSWORD_PLACEHOLDER = exports.PASSWORD_LABEL = exports.LAST_NAME_PLACEHOLDER = exports.LAST_NAME_LABEL = exports.FIRST_NAME_PLACEHOLDER = exports.FIRST_NAME_LABEL = exports.EMAIL_PLACEHOLDER = exports.EMAIL_LABEL = void 0; // Sign Up Component

var FIRST_NAME_LABEL = "First Name";
exports.FIRST_NAME_LABEL = FIRST_NAME_LABEL;
var FIRST_NAME_PLACEHOLDER = "Enter First Name Here";
exports.FIRST_NAME_PLACEHOLDER = FIRST_NAME_PLACEHOLDER;
var LAST_NAME_LABEL = "Last Name";
exports.LAST_NAME_LABEL = LAST_NAME_LABEL;
var LAST_NAME_PLACEHOLDER = "Enter Last Name Here";
exports.LAST_NAME_PLACEHOLDER = LAST_NAME_PLACEHOLDER;
var EMAIL_LABEL = "Email";
exports.EMAIL_LABEL = EMAIL_LABEL;
var EMAIL_PLACEHOLDER = "Enter Email Here";
exports.EMAIL_PLACEHOLDER = EMAIL_PLACEHOLDER;
var PASSWORD_LABEL = "Password";
exports.PASSWORD_LABEL = PASSWORD_LABEL;
var PASSWORD_PLACEHOLDER = "Enter Password Here";
exports.PASSWORD_PLACEHOLDER = PASSWORD_PLACEHOLDER;
var SIGN_UP_BUTTON_TEXT = "Sign Up";
exports.SIGN_UP_BUTTON_TEXT = SIGN_UP_BUTTON_TEXT;
var _default = {
  FIRST_NAME_LABEL: FIRST_NAME_LABEL,
  FIRST_NAME_PLACEHOLDER: FIRST_NAME_PLACEHOLDER,
  LAST_NAME_LABEL: LAST_NAME_LABEL,
  LAST_NAME_PLACEHOLDER: LAST_NAME_PLACEHOLDER,
  EMAIL_LABEL: EMAIL_LABEL,
  EMAIL_PLACEHOLDER: EMAIL_PLACEHOLDER,
  PASSWORD_LABEL: PASSWORD_LABEL,
  PASSWORD_PLACEHOLDER: PASSWORD_PLACEHOLDER,
  SIGN_UP_BUTTON_TEXT: SIGN_UP_BUTTON_TEXT
};
exports["default"] = _default;